module.exports = __webpack_public_path__ + "img/topup_on.f191ea06.svg";